// extracted by mini-css-extract-plugin
module.exports = {"contactLink":"styles-module--contactLink--9i-MB","label":"styles-module--label--213no","content":"styles-module--content--3mG3y"};